import { combineReducers } from 'redux';
import { IAppState } from './models/reduxState';
import { GlobalReducer as GlobalState } from './packages/app/reducers/globalReducer';
import { NavReducer as NavState } from './packages/app/reducers/navReducer';
import { ContactUsReducer as ContactState } from './packages/contactUs/reduxUpdater/reducers/contactUsReducer';

export const reducers = combineReducers<IAppState>({
    GlobalState,
    NavState,
    ContactState,
});
